module.exports = __webpack_public_path__ + "static/img/TCashIcon.2877ac65.png";